import { Language } from './_autogenerated_';

export * from './_autogenerated_';
export * from './src';

export const DEFAULT_LANGUAGE = Language.NL;
export const FALLBACK_LANGUAGE = Language.NL;
